import { useMemo } from "react";
import Tabs, { SubTab } from "../../../../components/Tabs";
import { ReportLevel } from "../adminReportsApiSlice";
import { UsageAndPerformanceByPromptRow } from "./adminPromptReportApiSlice";
import { EssayAndDraftCountUsageChart } from "../shared/EssayAndDraftCountUsageChart";
import { TraitScoresChart } from "../shared/TraitScoresChart";

export enum UsageAndPerformanceByPromptSubTabs {
	Usage = "Prompt Usage",
	AvgScores = "Prompt Performance",
}

interface ChartProps {
	level: ReportLevel;
	data: UsageAndPerformanceByPromptRow[];
	hasData: boolean;
}

export default function UsageAndPerformanceByPromptChart(props: ChartProps) {
	const initialSubTabs: SubTab[] = useMemo(
		() => [
			{
				name: UsageAndPerformanceByPromptSubTabs.Usage,
				current: true,
				content: (
					<EssayAndDraftCountUsageChart
						level={props.level}
						data={props.data}
						hasData={props.hasData}
						title={`${props.level} Usage by Prompt`}
						yAxisDataField="promptName"
						isEssayAndDraftSummaryChart={false}
					/>
				),
			},
			{
				name: UsageAndPerformanceByPromptSubTabs.AvgScores,
				current: false,
				content: (
					<TraitScoresChart
						level={props.level}
						data={props.data}
						hasData={props.hasData}
						title={`${props.level} Holistic and Trait Scores by Prompt`}
						yAxisDataField="promptName"
						totalScoreField="averageScore"
					/>
				),
			},
		],
		[props]
	);

	return (
		props.hasData && (
			<div className="print:hidden mt-8">
				<Tabs
					initialSubTabs={initialSubTabs}
					ariaLabel="Prompt Chart Tabs"
					containerClass="px-4"
				/>
			</div>
		)
	);
}
